import Carousel from "../../Carousel/Carousel";
import Cards from "../Cards/Cards";
import Footer from "../Footer/Footer";
import HeroSection from "../HeroSection/HeroSection";
import Moto from "../Moto/Moto";
import Navbar from "../Navbar/Navbar";
import styles from "./Home.module.css";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="keywords"
          content="Shine International School, Jamudag, Ranchi, quality education, best school in Ranchi, modern facilities, school admissions, excellence in education"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Shine International School Team" />
        <meta
          property="og:title"
          content="Shine International School, Jamudag - Quality Education in Ranchi"
        />
        <meta
          property="og:description"
          content="Experience world-class education at Shine International School in Ranchi. Established in 2014, we focus on holistic development and academic excellence."
        />
        <meta property="og:url" content="https://sisjamudag.in" />
        <meta property="og:type" content="website" />
        <title>Shine International School, Jamudag</title>
      </Helmet>
      <div
        style={{
          height: "100%",
          margin: "0",
          padding: "0",
          backgroundImage:
            "linear-gradient(90.1deg, rgba(8, 81, 98, 1) 14.5%, rgb(243, 198, 249) 135.4%)",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        <Navbar />
        <HeroSection />
        {/* <Carousel /> */}
        <Moto />
        <Cards />
        <Footer />
      </div>
    </>
  );
};

export default Home;
